module.exports = __webpack_public_path__ + "static/img/policyType4-banner.796c8496.png";